<template>
  <v-dialog v-model="show" max-width="700px" persistent>
    <v-card class="pa-3">
      <v-card-title class="primary elevation-4">
        <span class="headline white--text">{{
          fieldOption.id === 0 ? "Add New Field" : "Update Field"
        }}</span>
      </v-card-title>
      <input type="hidden" v-model="fieldOption.id" />
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="Component Name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Component Name"
                  name="componentName"
                  :error-messages="errors"
                  v-model="fieldOption.componentName"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="Ref"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Ref"
                  name="ref"
                  :error-messages="errors"
                  v-model="fieldOption.ref"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="Option"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :items="optionMenu"
                  label="Select option"
                  name="option"
                  item-value="value"
                  :error-messages="errors"
                  v-model="fieldOption.option"
                ></v-select>
              </ValidationProvider>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="Option"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  name="rule"
                  label="Rules"
                  v-model="fieldOption.rule"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn color="error" v-if="fieldOption.id !== 0" @click="remove">
          <v-icon color="white">delete</v-icon>Delete</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">Save</v-btn>
        <v-btn color="light-grey" @click="hide">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { FieldOption } from "@/models/FieldOption";
export default {
  name: "UpdateFieldOption",
  data() {
    return {
      fieldOption: new FieldOption(),
      optionMenu: [
        { id: 0, value: "hidden", text: "Hidden" },
        { id: 1, value: "disabled", text: "Disabled" },
        { id: 2, value: "readwrite", text: "Read & Write" },
      ],
    };
  },
  props: {
    show: { type: Boolean, required: true },
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
    save() {
      this.$emit("save", this.fieldOption);
    },
    remove() {
      if (confirm("Do you want to remove this item?")) {
        this.$emit("remove", this.fieldOption.id);
      }
    },
  },
};
</script>
